export default "__VITE_ASSET__BQHrW5KD__"